const $$splitComponentImporter = () => import('/Users/vthang/projects/marvy/marvy_mono/apps/pinktool/src/routes/_app/boards/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_app/boards/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});

// Modal Component for Create/Edit Board
interface BoardModalProps {
  isOpen: boolean;
  onClose: () => void;
  board?: any;
  onSubmit: (data: {
    name: string;
    description: string;
    cover_image?: string;
    target_account_id?: string;
  }) => void;
  isLoading?: boolean;
}
// Board Card Component
interface BoardCardProps {
  board: any;
  onToggleFavorite: (board: any) => void;
  onEdit: (board: any) => void;
  onNavigate: (board: any) => void;
  isUpdatingFavorite?: boolean;
  viewMode?: "grid" | "list";
  isLast?: boolean;
}